'use strict';

import { range } from 'lodash';
import { Injectable, Inject } from 'ng-metadata/core';
import { timeout } from 'rxjs/operator/timeout';
import { getVid } from '../../../../appConfig/appConfigForward';
import { SharedSessionStorage } from '../../../../infra/sharedSessionStorage.service';
import { ResultUtil } from '../../../../nddUtils/resultUtil.service';
import { StringUtils } from '../../../../nddUtils/stringUtils.service';
import { JwtUtilService } from '../../../../security/jwtUtil.service';

const NUM_OF_PAGE_LINKS = 5;
const PAGES_TO_SHOW_50_BULK_WITHOUT_PAGE_BEFORE_OR_AFTER = 2;
const PAGES_TO_SHOW_50_BULK = 1;

@Injectable()
export class PageNavMenuService {

    private _pageInView: number;
    private _needToUpdatePivInSafari: boolean;
    private _startPage: number;
    private _PAGE_SIZE: number;
    private _numOfLoadedPagesVal: number;
    private _numOfResultsVal: number;
    private _maxDisplayResultsVal: number;
    private _currentPageVal: number;
    public availablePages: Array<number> = [];
    private vid = getVid();
    private _lowerRange: number;
    private _higherRange: number;
    private _currentPageNumVal: number;
    private _totalResultsVal: number;
    private userSettingsUrl: string;
    private _rangeTitle: string;
    private _page_size_temp: number;

    constructor(@Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
        private jwtUtilService: JwtUtilService,
        private resultUtil: ResultUtil,
        private sharedSessionStorage: SharedSessionStorage,
        private stringUtils: StringUtils,
        @Inject('$http') private $http: ng.IHttpService,
        @Inject('restBaseURLs') private restBaseURLs,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService) {
        this.$http = $http;
        this.userSettingsUrl = restBaseURLs.userSettingsBaseURL;
    }

    get pageInView(): number {
        return this._pageInView;
    }

    set pageInView(updatedPage: number) {
        this._pageInView = updatedPage;
    }

    get needToUpdatePivInSafari(): boolean {
        return this._needToUpdatePivInSafari;
    }

    set needToUpdatePivInSafari(isNeedToUpdate: boolean) {
        this._needToUpdatePivInSafari = isNeedToUpdate;
    }

    get startPage(): number {
        return this._startPage;
    }

    set startPage(startPage: number) {
        this._startPage = startPage;
    }

    get PAGE_SIZE(): number {
        return this._PAGE_SIZE;
    }

    set PAGE_SIZE(PAGE_SIZE: number) {
        this._PAGE_SIZE = PAGE_SIZE;
    }

    get numOfLoadedPagesVal(): number {
        return this._numOfLoadedPagesVal;
    }

    set numOfLoadedPagesVal(numOfLoadedPagesVal: number) {
        this._numOfLoadedPagesVal = numOfLoadedPagesVal;
    }

    get numOfResultsVal(): number {
        return this._numOfResultsVal;
    }

    set numOfResultsVal(numOfResultsVal: number) {
        this._numOfResultsVal = numOfResultsVal;
    }

    get maxDisplayResultsVal(): number {
        return this._maxDisplayResultsVal;
    }

    set maxDisplayResultsVal(maxDisplayResultsVal: number) {
        this._maxDisplayResultsVal = maxDisplayResultsVal;
    }

    get currentPageVal(): number {
        return this._currentPageVal;
    }

    set currentPageVal(currentPageVal: number) {
        this._currentPageVal = currentPageVal;
    }

    get currentPageNumVal(): number {
        return this._currentPageNumVal;
    }

    set currentPageNumVal(currentPageNumVal: number) {
        this._currentPageNumVal = currentPageNumVal;
    }

    get totalResultsVal(): number {
        return this._totalResultsVal;
    }

    set totalResultsVal(totalResultsVal: number) {
        this._totalResultsVal = totalResultsVal;
    }

    get lowerRange(): number {
        return this._lowerRange;
    }

    set lowerRange(value: number) {
        this._lowerRange = value;
    }

    get higherRange(): number {
        return this._higherRange;
    }

    set higherRange(value: number) {
        this._higherRange = value;
    }

    get maxPage() {
        return Math.ceil(this.numOfResultsVal / this.PAGE_SIZE);
    }

    get maxDisplayPage() {
        return Math.ceil(this.maxDisplayResultsVal / this.PAGE_SIZE);
    }

    get rangeTitle() {
        return this._rangeTitle;
    }

    set rangeTitle(rangeTitle: string) {
        this._rangeTitle = rangeTitle;
    }

    get page_size_temp() {
        return this._page_size_temp;
    }

    set page_size_temp(page_size_temp: number) {
        this._page_size_temp = page_size_temp;
    }
    
    public saveNumOfPageToLocalForage(size: number) {
        let resultsPerPage = size;
        let user = this.jwtUtilService.getDecodedToken().user;
        this.sharedSessionStorage.setItem('resultsBulkSize', size.toString());
        this.resultUtil.updatedBulkSize = size;
    }

    public updateBulkSizePerPageInDB(size: number) {
        let payload = {
            'vid': this.vid,
            'resultsBulkSize': size
        };
        this.$http.post(this.userSettingsUrl, payload).then(
            (response) => {},
            (error) => {
                return this.failurePostAction(error);
            }
        );
    }


    private failurePostAction(reason) {
        console.error(reason);
        return reason;
    }

    public initPageList() {
        if(this.PAGE_SIZE == 0){
            this.PAGE_SIZE = this.page_size_temp;
        }
        let offset = this.$stateParams['offset'] ? this.$stateParams['offset'] : 0;
        this.startPage = Math.floor(offset / this.PAGE_SIZE) + 1;
        let loadedPageNum = this.startPage + this.numOfLoadedPagesVal - 1;
        let numOfSidePages = Math.floor(NUM_OF_PAGE_LINKS / 2);
        let pagesBeforeStartPage = Math.min(loadedPageNum - numOfSidePages + 1, numOfSidePages);
        let pagesAfterStartPage = numOfSidePages + (numOfSidePages - pagesBeforeStartPage);
        pagesBeforeStartPage += numOfSidePages - Math.min(this.maxPage - loadedPageNum, numOfSidePages);
        if (this.PAGE_SIZE === 50) {
            pagesBeforeStartPage = this.startPage === this.maxPage ? PAGES_TO_SHOW_50_BULK_WITHOUT_PAGE_BEFORE_OR_AFTER : PAGES_TO_SHOW_50_BULK;
            pagesAfterStartPage = this.startPage === 1 ? PAGES_TO_SHOW_50_BULK_WITHOUT_PAGE_BEFORE_OR_AFTER : PAGES_TO_SHOW_50_BULK;
        }

        let maxDisplayPage = this.maxPage;
        if (this.maxDisplayPage) {
            maxDisplayPage = Math.min(this.maxDisplayPage, this.maxPage);

        }

        this.availablePages = range(Math.max(loadedPageNum - pagesBeforeStartPage, 1), Math.min(loadedPageNum + pagesAfterStartPage, maxDisplayPage) + 1);
        if (this.currentPageVal > this.maxDisplayPage) {
            this.availablePages = [this.maxDisplayPage];
        }
    }

    public getResultNumberRange() {
        let higherRangeValue = this.currentPageNumVal * this.PAGE_SIZE;
        if (higherRangeValue > this.totalResultsVal) {
            this.higherRange = this.totalResultsVal;
            this.lowerRange = higherRangeValue - this.PAGE_SIZE + 1;
        }
        else {
            this.higherRange = higherRangeValue;
            this.lowerRange = this.higherRange - this.PAGE_SIZE + 1;
        }
    }

    public updateRangeTitle(){
        this.updateSelectedText();
        this.page_size_temp = this.PAGE_SIZE;
        this.PAGE_SIZE = 0;
        this.$timeout(() => { //simulate change in md-select
            this.PAGE_SIZE =  this.page_size_temp;
        }, 0);
    }

    public updateSelectedText() {
        if (!this.totalResultsVal || !this.lowerRange || !this.higherRange) {
            this.rangeTitle = "";
        }
        else {
            let norm_lang = this.$translate.use().replace("_", "-"); //Numbers in each language may have a different seperators (comma, space, dot,...)
            let placeHolders = {
                resultsRange: this.lowerRange.toLocaleString(norm_lang) + '-' + this.higherRange.toLocaleString(norm_lang),
                totalNumberOfResults: this.totalResultsVal.toLocaleString(norm_lang)
            };
            this.$translate('nui.results.title.resultsDisplayed', placeHolders).then((translation) => {
                this.rangeTitle = this.stringUtils.decode(translation + ' ' + this.$translate.instant('results.title'));
            });
        }
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/pageNavMenu/pageNavMenu.service.ts